module.exports = __webpack_public_path__ + "img/result.bb2821e9.png";